/*!
 * 7magicexperiments.com 
 *  
 * Art Samvelyan 
 */

(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var _accordion = _interopRequireDefault(require("../../js-modules/accordion"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(0, _accordion.default)();
var headerAnchorBtn = document.querySelector('.header .btn');

if (headerAnchorBtn) {
  var anchorEl = document.getElementsByClassName('atc-box')[0];

  if (anchorEl) {
    headerAnchorBtn.addEventListener('click', function () {
      if ('scrollBehavior' in document.documentElement.style) {
        anchorEl.scrollIntoView({
          block: 'start'
        });
      } else {
        anchorEl.scrollIntoView(false);
      }
    }, false);
  }
}

var prePurchaseBtns = document.getElementsByClassName('pre-purchase');
var prePurchasePop = document.getElementById('pre-purchase-popup');
var prePurchasePopCloseBtn = prePurchasePop.getElementsByClassName('close-btn')[0];
prePurchasePopCloseBtn.addEventListener('click', function () {
  prePurchasePop.classList.remove('active');
}, false);

var _iterator = _createForOfIteratorHelper(prePurchaseBtns),
    _step;

try {
  var _loop = function _loop() {
    var prePurchaseBtn = _step.value;
    prePurchaseBtn.addEventListener('click', function (e) {
      e.preventDefault();

      if (!prePurchasePop) {
        window.location(prePurchaseBtn.getAttribute('href'));
        return false;
      }

      prePurchasePop.classList.add('active');
    });
  };

  for (_iterator.s(); !(_step = _iterator.n()).done;) {
    _loop();
  }
} catch (err) {
  _iterator.e(err);
} finally {
  _iterator.f();
}

},{"../../js-modules/accordion":2}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default() {
  document.querySelectorAll('.accordion .accordion__item').forEach(function (item) {
    return item.addEventListener('click', function (e) {
      e.currentTarget.classList.toggle('active');
    });
  });
};

exports.default = _default;

},{}]},{},[1]);
